import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './styles.css';
import { initializeBlockchain } from './utils/blockchain-init';

// Chart.js type declaration
declare global {
  interface Window {
    Chart: any;
    openCoinDetails?: (coinId: string) => void;
  }
}

// Initialize blockchain utilities before rendering
initializeBlockchain();

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

